/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React, { useContext, useState } from 'react';
import {
  makeStyles, useMediaQuery, Box, Typography, Button,
  Modal,
  Backdrop,
  Fade,
} from '@material-ui/core';
import { useLocation } from '@reach/router';
import Whatsapp from '../../static/images/social/whatsApp.png';
import FormCard from '../organisms/FormCard';
import StyledModal from './StyledModal';
import SwitchAccountantFormDesk from '../organisms/SwitchAccountantFormDesk';
import HownMuchOrOpenCompanyFormDesk from '../organisms/HowMuchOrOpenCompanyFormDesk';
import FormButtonWhatsappOnly from '../organisms/FormButtonWhatsappOnly';
import { addTagFirebaseAnalytcs, tagsAnalytcs } from '../../analytcs/firebase';
import { NotificationModalContext } from '../../contexts/NotificationModalContext';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    position: 'fixed',
    zIndex: 1000,
    borderTop: '1px solid #60CD5F',
    bottom: 0,
  },
  container: {
    height: '84px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    gap: '12px',
    padding: '0 16px',
  },
  description: {
    '& .MuiTypography-subtitle2': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.2,
      color: '#2E2E2E',
    },
    '& .doubt': {
      fontWeight: 700,
    },
  },
  closeButton: {
    zIndex: 1200,
    position: 'absolute',
    right: '8px',
    lineHeight: 0.8,
    minWidth: 'auto',
    top: '8px',
  },
  whatsappButton: {
    backgroundColor: '#60CD5F',
    color: '#FFFFFF',
    minWidth: 'max-content',

    '&:hover': {
      backgroundColor: '#56bb55ff',
    },

    '& .MuiButton-label': {
      textTransform: 'uppercase',
      lineHeight: 1.2,
    },
  },
}));

const FooterWhatsapp = ({ isFooterWidgetOpen, setIsFooterWidgetOpen }) => {
  const { pathname } = useLocation();

  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:960px)');
  const [modalWhatsAppOpen, setModalWhatsAppOpen] = useState(false);

  const btnWhatsQuemsomosRodapeMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_quemsomos_rodape_mobile);
  const btnWhatsQuemsomosRodapeMobileForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_quemsomos_rodape_mobile_form);
  const btnWhatsQuemsomosRodapeDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_quemsomos_rodape_desk);
  const btnWhatsQuemsomosRodapeDeskForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_quemsomos_rodape_desk_form);
  const btnWhatsSolucoesRodapeMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_solucoes_rodape_mobile);
  const btnWhatsSolucoesRodapeMobileForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_solucoes_rodape_mobile_form);
  const btnWhatsSolucoesRodapeDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_solucoes_rodape_desk);
  const btnWhatsSolucoesRodapeDeskForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_solucoes_rodape_desk_form);
  const btnWhatsHomeRodapeMobile = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_home_rodape_mobile);
  const btnWhatsHomeRodapeMobileForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_home_rodape_mobile_form);
  const btnWhatsHomeRodapeDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_home_rodape_desk);
  const btnWhatsHomeRodapeDeskForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_home_rodape_desk_form);
  const btnWhatsRodapeQuantoMob = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_quanto_mob);
  const btnWhatsRodapeQuantoMobForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_quanto_mob_form);
  const btnWhatsRodapeQuantoDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_quanto_desk);
  const btnWhatsRodapeQuantoDeskForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_quanto_desk_form);
  const btnWhatsRodapeTrocarMob = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_trocar_mob);
  const btnWhatsRodapeTrocarMobForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_trocar_mob_form);
  const btnWhatsRodapeTrocarDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_trocar_desk);
  const btnWhatsRodapeTrocarDeskForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_trocar_desk_form);
  const btnWhatsRodapeAbrirMob = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_abrir_mob);
  const btnWhatsRodapeAbrirMobForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_abrir_mob_form);
  const btnWhatsRodapeAbrirDesk = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_abrir_desk);
  const btnWhatsRodapeAbrirDeskForm = () => addTagFirebaseAnalytcs(tagsAnalytcs.btn_whats_rodape_abrir_desk_form);

  const { setOpenModal } = useContext(NotificationModalContext);

  // TXM-366: id do botao do widget de WhatsApp do rodape, por pagina/dispositivo
  const rodapeWidgetId = {
    '/trocar-contador/': isMobile ? 'btn_whats_rodape_trocar_mob' : 'btn_whats_rodape_trocar_desk',
    '/': isMobile ? 'btn_whats_home_rodape_mobile' : 'btn_whats_home_rodape_desk',
    '/solucoes/': isMobile ? 'btn_whats_solucoes_rodape_mobile' : 'btn_whats_solucoes_rodape_desk',
    '/abrir-empresa/': isMobile ? 'btn_whats_rodape_abrir_mob' : 'btn_whats_rodape_abrir_desk',
    '/quanto-custa/': isMobile ? 'btn_whats_rodape_quanto_mob' : 'btn_whats_rodape_quanto_desk',
    '/quem-somos/': isMobile ? 'btn_whats_quemsomos_rodape_mobile' : 'btn_whats_quemsomos_rodape_desk',
  }[pathname];

  const getForm = ({
    path, setOriginModal,
  }) => {
    if (isMobile) {
      return (
        <FormButtonWhatsappOnly
          tagWpp={() => {
            if (path === '/trocar-contador/') btnWhatsRodapeTrocarMobForm();
            if (path === '/') btnWhatsHomeRodapeMobileForm();
            if (path === '/solucoes/') btnWhatsSolucoesRodapeMobileForm();
            if (path === '/abrir-empresa/') btnWhatsRodapeAbrirMobForm();
            if (path === '/quanto-custa/') btnWhatsRodapeQuantoMobForm();
            if (path === '/quem-somos/') btnWhatsQuemsomosRodapeMobileForm();
          }}
          notConvert
          originModal={setOriginModal}
        />
      );
    }
    if (path === '/trocar-contador/' && !isMobile) {
      return (
        <FormCard color="#0CB49D" title="Quero trocar de contador">
          <SwitchAccountantFormDesk
            originModal={setOriginModal}
            hubspotAction="trocar-contador"
            whatsappOnly
            btnWppTag={btnWhatsRodapeTrocarDeskForm}
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }
    if ((path === '/' || path === '/solucoes/') && !isMobile) {
      return (
        <FormCard color="#0093F5" title="Preencha as informações abaixo">
          <HownMuchOrOpenCompanyFormDesk
            originModal={setOriginModal}
            hubspotAction="trocar-contador"
            whatsappOnly
            tagWppDesktop={path === '/' ? btnWhatsHomeRodapeDeskForm : btnWhatsSolucoesRodapeDeskForm}
            idWpp={rodapeWidgetId && `${rodapeWidgetId}_form`}
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }
    if (path === '/quem-somos/') {
      return (
        <FormCard color="#0093F5" title="Preencha as informações abaixo">
          <HownMuchOrOpenCompanyFormDesk
            originModal={setOriginModal}
            hubspotAction="trocar-contador"
            whatsappOnly
            tagWppDesktop={btnWhatsQuemsomosRodapeDeskForm}
            idWpp={rodapeWidgetId && `${rodapeWidgetId}_form`}
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }
    if ((path === '/quanto-custa/') && !isMobile) {
      return (
        <FormCard color="#0093F5" title="Estou abrindo empresa">
          <HownMuchOrOpenCompanyFormDesk
            originModal={setOriginModal}
            hubspotAction="trocar-contador"
            tagWppDesktop={btnWhatsRodapeQuantoDeskForm}
            idWpp={rodapeWidgetId && `${rodapeWidgetId}_form`}
            whatsappOnly
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }
    if ((path === '/abrir-empresa/') && !isMobile) {
      return (
        <FormCard color="#2370FF" title="Estou abrindo empresa">
          <HownMuchOrOpenCompanyFormDesk
            originModal={setOriginModal}
            color="#2370FF"
            hubspotAction="abrir-empresa"
            whatsappOnly
            tagWppDesktop={btnWhatsRodapeAbrirDeskForm}
            idWpp={rodapeWidgetId && `${rodapeWidgetId}_form`}
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }

    if (path === '/servicos-paralegais/' && !isMobile) {
      return (
        <FormCard color="#0093F5" title="Preencha as informações abaixo">
          <HownMuchOrOpenCompanyFormDesk
            originModal={setOriginModal}
            hubspotAction="trocar-contador"
            whatsappOnly
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }

    if (path.includes('/calculadora') && !isMobile) {
      return (
        <FormCard color="#0093F5" title="Preencha as informações abaixo">
          <HownMuchOrOpenCompanyFormDesk
            originModal={setOriginModal}
            hubspotAction="trocar-contador"
            whatsappOnly
            onSuccess={() => setOpenModal(true)}
            notConvert
          />
        </FormCard>
      );
    }

    return null;
  };

  if (isMobile && !isFooterWidgetOpen) {
    return (
      <>
        <Button
          onClick={() => setModalWhatsAppOpen(true)}
          style={{
            position: 'fixed',
            bottom: '8px',
            right: '8px',
            zIndex: 1200,
            backgroundColor: '#60CD5F',
            borderRadius: '50%',
            width: '48px',
            height: '48px',
            minWidth: 'auto',
            '&:hover': {
              backgroundColor: '#4CAF50',
            },
          }}
          aria-label="Abrir chat do WhatsApp"
        >
          <img src={Whatsapp} alt="Ícone do WhatsApp" width="27" height="27" />
        </Button>

        <StyledModal open={modalWhatsAppOpen} setOpen={setModalWhatsAppOpen}>
          <FormButtonWhatsappOnly notConvert originModal={setModalWhatsAppOpen} />
        </StyledModal>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {isMobile && isFooterWidgetOpen && (
        <Button
          className={classes.closeButton}
          onClick={() => {
            setIsFooterWidgetOpen(false);
          }}
          aria-label="Fechar chat do WhatsApp"
          size="small"
        >
          X
        </Button>
        )}

        <Box className={classes.description}>
          {!isMobile && <Typography className="doubt" variant="subtitle2">Ficou com dúvidas?</Typography>}
          <Typography style={{ textAlign: isMobile && 'center' }} variant="subtitle2">
            Fale agora mesmo com nossos especialistas.
          </Typography>
        </Box>

        <Button
          id={rodapeWidgetId}
          onClick={() => {
            if (isMobile && pathname === '/trocar-contador/') btnWhatsRodapeTrocarMob();
            if (isMobile && pathname === '/') btnWhatsHomeRodapeMobile();
            if (isMobile && pathname === '/solucoes/') btnWhatsSolucoesRodapeMobile();
            if (isMobile && pathname === '/abrir-empresa/') btnWhatsRodapeAbrirMob();
            if (isMobile && pathname === '/quanto-custa/') btnWhatsRodapeQuantoMob();
            if (isMobile && pathname === '/quem-somos/') btnWhatsQuemsomosRodapeMobile();
            if (!isMobile && pathname === '/trocar-contador/') btnWhatsRodapeTrocarDesk();
            if (!isMobile && pathname === '/') btnWhatsHomeRodapeDesk();
            if (!isMobile && pathname === '/solucoes/') btnWhatsSolucoesRodapeDesk();
            if (!isMobile && pathname === '/abrir-empresa/') btnWhatsRodapeAbrirDesk();
            if (!isMobile && pathname === '/quanto-custa/') btnWhatsRodapeQuantoDesk();
            if (!isMobile && pathname === '/quem-somos/') btnWhatsQuemsomosRodapeDesk();
            setModalWhatsAppOpen(true);
          }}
          className={classes.whatsappButton}
          startIcon={<img src={Whatsapp} alt="Ícone do WhatsApp" width="27" height="27" />}
        >
          whatsapp
        </Button>
      </div>

      <StyledModal open={modalWhatsAppOpen} setOpen={setModalWhatsAppOpen}>
        {getForm({ path: pathname, isMobile, setOriginModal: setModalWhatsAppOpen })}
      </StyledModal>
    </div>
  );
};

export default FooterWhatsapp;
